<div class="container-fluid glb-popup">
  <h2>{{ formTitle }}</h2>
  <p-toast [style]="{ marginTop: '80px' }"></p-toast>
  <p-confirmDialog
    header="Confirmation"
  icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button
    mat-icon-button
    [mat-dialog-close]="true"
    style="float: right; top: -50px; background-color: transparent">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">
      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
            <div class="w-100"  style="text-align: center;background-color: yellow;padding: 5px;margin-bottom: 15px;">
              <p><b>{{ formAlert }}</b></p>
            </div>
          </div>
        }
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="senderName" id="senderName" type="text" pInputText/>
          <label for="senderName">Sender Name</label>
          @for (validation of validationMessages.senderName; track validation) {
            <span>
              @if (form1.get('senderName').hasError(validation.type) && (form1.get('senderName').dirty || form1.get('senderName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="senderEmail" id="senderEmail" type="email" pInputText/>
          <label for="senderEmail">Sender Email</label>
          @for (validation of validationMessages.senderEmail; track validation) {
            <span>
              @if (form1.get('senderEmail').hasError(validation.type) && (form1.get('senderEmail').dirty || form1.get('senderEmail').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      @if (!showSendToNewUser) {
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-chips class="mailinput"  [addOnTab]="true" [addOnBlur]="true" (keydown)="onKeyDown($event)" formControlName="toEmail"
            id="toEmail" [allowDuplicate]="false" (onAdd)="validateEmailAddress($event, this.form1.value.toEmail);"></p-chips>
            <label for="toEmail">To:</label>
            @for (validation of validationMessages.toEmail; track validation) {
              <span>
                @if (form1.get('toEmail').hasError(validation.type) && (form1.get('toEmail').dirty || form1.get('toEmail').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      }

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-chips class="mailinput" [addOnTab]="true" [addOnBlur]="true" (keydown)="onKeyDown($event)"formControlName="ccEmail"
          id="ccEmail" [allowDuplicate]="false" (onAdd)="validateEmailAddress($event, this.form1.value.ccEmail);"></p-chips>
          <label for="ccEmail">Cc:</label>
          @for (validation of validationMessages.ccEmail; track validation) {
            <span>
              @if ((form1.get('ccEmail').hasError(validation.type) &&
                form1.get('ccEmail').dirty) ||form1.get('ccEmail').touched) {
                <small class="p-invalid">{{ validation.message }}</small>
              }</span>
            }
          </span>

        </div>
        @if (showTags) {
          <div class="col-lg-6">
            <app-tag-join-select
              [tagSource]="80" [tagSourceId]="0" tagType="4" [viewOnly]="true" (tagsSelectedEvent)="ccTagAdded($event)">
            </app-tag-join-select>
          </div>
        }

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-chips class="mailinput" [addOnTab]="true" [addOnBlur]="true" (keydown)="onKeyDown($event)"formControlName="bccEmail"
            id="bccEmail" [allowDuplicate]="false" (onAdd)="validateEmailAddress($event, this.form1.value.bccEmail);"></p-chips>
            <label for="bccEmail">Bcc:</label>@for (validation of validationMessages.bccEmail; track validation) {
            <span>
              @if ((form1.get('bccEmail').hasError(validation.type) && form1.get('bccEmail').dirty) ||
                form1.get('bccEmail').touched) {
                <small class="p-invalid">{{ validation.message }}</small>
              }</span>
            }</span>

          </div>
          @if (showTags) {
            <div class="col-lg-6">
              <app-tag-join-select
                [tagSource]="80" [tagSourceId]="0" tagType="4" [viewOnly]="true" (tagsSelectedEvent)="toTagAdded($event)">
              </app-tag-join-select>
            </div>
          }
          <div class="col-lg-6"></div>
          @if (showTags) {
            <div class="col-lg-6">
              <app-tag-join-select
                [tagSource]="80" [tagSourceId]="0" tagType="4" [viewOnly]="true" (tagsSelectedEvent)="bccTagAdded($event)">
              </app-tag-join-select>
            </div>
          }
          @if (showSendToNewUser) {
            <div>
              <div class="row mb-3">
                @for (item of users.controls; track item; let i = $index) {
                  <div [formGroup]="item"
                    class="floating-form row g-1">
                    <div class="col-10 row">
                      <div class="col-lg-3 mb-0">
                        <span class="p-float-label required-field w-100">
                          <input name="firstName" required formControlName="firstName"  type="text" pInputText/>
                          <label for="firstName">First Name</label>
                        </span>
                      </div>
                      <div class="col-lg-3 mb-0">
                        <span class="p-float-label required-field w-100">
                          <input name="lastName" required formControlName="lastName" type="text" pInputText/>
                          <label for="lastName">Last Name</label>
                        </span>
                      </div>
                      <div class="col-lg-3 mb-0">
                        <span class="p-float-label required-field w-100">
                          <input name="emailAddress" required formControlName="emailAddress" type="text" pInputText/>
                          <label for="emailAddress">Email</label>
                        </span>
                      </div>
                      <div class="col-lg-3 mb-0">
                        <span class="p-float-label required-field w-100">
                          <input name="mobilePhone" formControlName="mobilePhone" type="text" pInputText/>
                          <label for="mobilePhone">Mobile</label>
                        </span>
                      </div>
                    </div>
                    <div class="col-2 row">
                      <div class="col-6 py-0 d-flex justify-content-end align-items-center pe-0">
                        <button class="btn btn-icon btn-success rounded-pill" (click)="addUser()">
                          <i class="pi pi-plus"></i>
                        </button>
                      </div>
                      @if (users.length > 1) {
                        <div class="col-6 py-0 d-flex justify-content-end align-items-center pe-0">
                          <button class="btn btn-icon btn-danger rounded-pill" (click)="removeUser(i)">
                            <i class="pi pi-minus"></i>
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (showTemplate) {
            <div class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <p-dropdown class="w-100" [options]="msgTemplates" formControlName="msgTemplateId" optionLabel="name"
                  placeholder="Template"
                (onChange)="selectTemplate($event)"></p-dropdown>
                <label for="msgTemplateId">Select Template</label>
              </span>
            </div>
          }
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="subject" id="subject" type="text" pInputText/>
              <label for="subject">Subject</label>
              @for (validation of validationMessages.subject; track validation) {
                <span>
                  @if (form1.get('subject').hasError(validation.type) && (form1.get('subject').dirty || form1.get('subject').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>


          <div class="col-lg-12">
            <label for="emailHtml">Email Html</label>
            <span class="p-float-label required-field w-100 mb-3">
          <editor formControlName="emailHtml"  id="emailHtml" [init]="{	height: 500,base_url: '/tinymce',suffix: '.min',
          plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
              </editor>
              @for (validation of validationMessages.emailHtml; track validation) {
                <span
                  >@if (form1.get('emailHtml').hasError(validation.type) && (form1.get('emailHtml').dirty || form1.get('emailHtml').touched)) {
                  <small
                    class="p-invalid"
                  >{{ validation.message }}</small>
                }
              </span>
            }
          </span>
        </div>

        @if (msgId) {
          <div>
            <h6>Message status</h6>
            <div class="col-lg-6">
              <span class="p-float-label w-100 mb-3">
                <p-calendar formControlName="sentDate" inputId="sentDate" appendTo="body" readonly="true"></p-calendar>
                <label for="sentDate">Sent Date</label>
                @for (validation of validationMessages.sentDate; track validation) {
                  <span>
                    @if ( (form1.get('sentDate').hasError(validation.type) && form1.get('sentDate').dirty) ||
                      form1.get('sentDate').touched) {
                      <small class="p-invalid" >{{ validation.message }}</small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-6">
              <span class="p-float-label w-100 mb-3">
                <p-calendar
                  formControlName="receivedDate"
                  inputId="receivedDate"
                  appendTo="body"
                  readonly="true"
                  >
                </p-calendar>
                <label for="receivedDate">Received Date</label>
                @for (validation of validationMessages.receivedDate; track validation) {
                  <span>
                    @if (
                      (form1.get('receivedDate').hasError(validation.type) &&
                      form1.get('receivedDate').dirty) ||
                      form1.get('receivedDate').touched
                      ) {
                      <small
                        class="p-invalid"
                        >{{ validation.message }}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-6">
              <span class="p-float-label w-100 mb-3">
                <p-dropdown
                  class="w-100"
                  [options]="statuses"
                  formControlName="status"
                  optionLabel="name"
                  optionValue="value"
                  placeholder="status"
                ></p-dropdown>
                <label for="status">Status</label>
                @for (validation of validationMessages.status; track validation) {
                  <span>
                    @if (
                      (form1.get('status').hasError(validation.type) &&
                      form1.get('status').dirty) ||
                      form1.get('status').touched
                      ) {
                      <small
                        class="p-invalid"
                        >{{ validation.message }}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-6">
              <span class="p-float-label required-field w-100 mb-3">
                <input formControlName="statusMsg" id="statusMsg" type="text" pInputText/>
                <label for="statusMsg">Status Message</label>@for (validation of validationMessages.statusMsg; track validation) {
                <span>
                  @if ( (form1.get('statusMsg').hasError(validation.type) && form1.get('statusMsg').dirty) || form1.get('statusMsg').touched) {
                    <small class="p-invalid">
                    {{ validation.message }}</small>
                  }</span>
                }</span>
              </div>
              <div class="col-lg-6">
                <span class="p-float-label required-field w-100 mb-3"><input
                  formControlName="confId"
                  id="confId"
                  type="text"
                  readonly="true"
                  pInputText/><label for="confId">Conf Id</label>@for (validation of validationMessages.confId; track validation) {
                  <span>@if (
                    (form1.get('confId').hasError(validation.type) &&
                    form1.get('confId').dirty) ||
                    form1.get('confId').touched
                    ) {
                    <small
                      class="p-invalid"
                    >{{ validation.message }}</small>
                  }</span>
                }</span>
              </div>
              <div class="col-lg-6">
                <span class="p-float-label required-field w-100 mb-3"><input formControlName="trackingId" id="trackingId"
                  type="text"  readonly="true" pInputText/>
                <label for="trackingId">Tracking Id</label>@for (validation of validationMessages.trackingId; track validation) {
                <span>@if ( (form1.get('trackingId').hasError(validation.type) && form1.get('trackingId').dirty) ||
                  form1.get('trackingId').touched) {
                  <small
                  class="p-invalid">{{ validation.message }}</small>
                }</span>
              }</span>
            </div>
          </div>
        }
        <div class="row m-0">
          <div class="col-lg-12">
            <div class="btn-group">
              <div class="button-group">
              </div>

              <div class="button-group">
                <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Close</button>

                <button pButton  class="btn-addt p-button" (click)="addAndSendMail()">Send</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
